import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
      :host {
      all: initial;
      font-size: 16px;
      --box-shadow: 0px 0.3px 1.3px rgba(0, 0, 0, 0.04),
        0px 0.9px 4.5px rgba(0, 0, 0, 0.08), 0px 4px 20px rgba(0, 0, 0, 0.1);
      --primary-color: #00304d;
      --secondary-color: #fafafa;
      --color-neutral-0: #fdfdfd;
      --color-neutral-70: #444;
      --color-neutral-40: #ccc;
      --color-neutral-60: #595959;
      --color-neutral-20: #f0f0f0;
      --color-neutral-30: #dbdbdb;
      --tertiary-border-color: #949494;
      --color-blue: #1d5fc2;
      --color-white: #ffffff;
      --color-teal: #00857e;
      --color-teal-darkest: #006c67;
      --color-cobalt: #00819e;
      --color-grey: #dbdbdb;
      --color-green: #008a48;
      --color-pink: #f88bcc;
      --color-orange: #ffaf6b;
      --color-violet: #744fdb;
      --color-red: #d42d2d;
      --color-red-darker: #ca2121;
      --color-red-darkest: #b71a1a;
      --color-ruby: #b6026d;
      --color-yellow: #ffd980;
      --color-malibu: #0f7cc0;
      --color-midnight: #31577d;
      --color-midnight-lighter: #6583a4;
      --color-midnight-lightest: #8faac7;
      --color-midnight-dark: #002033;
      --color-midnight-darker: #06151e;
      --a11y: #4c9aff;

      /* Extra variables added for PersonalizationPanel */
      --brand-darker: var(--color-teal, #00857e);
      --color-background-surface: var(--color-white, #ffffff);
      --color-border-high-contrast: var(--tertiary-border-color, #949494);
      --color-border-mid-contrast: var(--color-neutral-30, #dbdbdb);
      --color-border-low-contrast: var(--color-neutral-20, #f0f0f0);
      --color-extended-subtle-blue: #eaf3fb;
      --color-midnight-base: var(--primary-color, #00304d);
      --color-text-high-contrast: var(--color-neutral-70, #444);
      --color-text-low-contrast: var(--color-neutral-60, #595959);
      }

      section { 
        font-family: 'Roboto', sans-serif;
        position: fixed; 
        z-index: 9999;
        top: 0;
        left: 0;
        width: 100%;
        height: 100dvh;
        pointer-events: none;
      }
    
      &.pointer-events--allow {
        pointer-events: all;
      }

      button {
        cursor: pointer;
        &:focus {
          outline: 0.125em solid transparent;
          box-shadow: inset 0 0 00.125em #fff;
        }
      }

      /* Remove default margin */
      body,
      h1,
      h2,
      h3,
      h4,
      p,
      figure,
      blockquote,
      dl,
      dd {
        margin: 0;
      }

      /* Remove list styles on ul, ol elements with a list role, which suggests default styling will be removed */
      ul[role='list'],
      ol[role='list'] {
        list-style: none;
      }

      /* Set core root defaults */
      section:focus-within {
        scroll-behavior: smooth;
      }

      /* A elements that don't have a class get default styles */
      a:not([class]) {
        text-decoration-skip-ink: auto;
      }

      /* Make images easier to work with */
      img,
      picture {
        max-width: 100%;
        display: block;
      }

      /* Inherit fonts for inputs and buttons */
      input,
      button,
      textarea,
      select {
        font: inherit;
      }

      /* Remove all animations, transitions and smooth scroll for people that prefer not to see them */
      @media (prefers-reduced-motion: reduce) {
        section:focus-within {
          scroll-behavior: auto;
        }

        *,
        *::before,
        *::after {
          animation-duration: 0.01ms !important;
          animation-iteration-count: 1 !important;
          transition-duration: 0.01ms !important;
          scroll-behavior: auto !important;
        }
      }

      /* https://www.a11yproject.com/posts/how-to-hide-content/ */
      .visually-hidden,
      .sr-only {
        clip: rect(0 0 0 0);
        clip-path: inset(50%);
        height: 1px;
        overflow: hidden;
        position: absolute;
        white-space: nowrap;
        width: 1px;
      }

      /* https://piccalil.li/quick-tip/flow-utility/ */
      /* If --flow doesn't exist it'll default to 1em */
      .flow > * + * {
        margin-top: var(--flow, 1em);
      }

    `;

export default GlobalStyle;
